import TechnicalOverlayFiltersByPeriod from './TechnicalOverlayFiltersByPeriod';

export default TechnicalOverlayFiltersByPeriod;
